import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrency } from '../features/user/userSlice';

function useWrapperDeposit(
  setActRetail,
  //setActAstro,
  setActDeposit,
  setActPagoEfectivo,
  setActTotalP,
  setActTotalPBFC,
  setActMonnetPeru,
  setActMonnetPeruYape,
  setActMonnetChileTarjeta,
  setActMonnetChileBancos,
  setActPFtigomoney,
  setActPFyape,
  setActPFqr,
  setActBinanceDolar,
  setActSpei,
  setActPix,
  setActBinanceBRL,
  setActBinanceOtroMXN,
  setActBinanceOtroARG,
  setActBinanceOtroCOP,
  setActBinanceOtroCLP,
  setActBinanceOtroDOP,
  setActBinanceOtroVES,
  setActBinanceOtroBOB,
  setActBinanceOtroEUR,
  setActCoinspaid,
  setActTotalPBNC,
  setActMibanco,
  setActPFqrbisa,
  setActPFqrMercantil,
  setActALpsPEN,
  setActALpsEfectivoCHL,
  setActALpsTarjetaCHL,
  setActALpsTransfCHL,
  setActKushkiTransPEN,
  setActKushkiEfectPEN,
  setActKushkiCardPEN,
  //setActSafeP
  setActOxxoMxn,
  setActMonnetGTQCash,
  setActMonnetGTQTransf,
  setActAstroCO,
  setActAstroCH,
  setActAstroARG,
  setActBetterbroPYG,
){
  const moneda = useSelector(selectCurrency);
    
  useEffect(()=>{
    switch (moneda.toUpperCase()) {
      case 'SOL':
        //setActAstro(true);
        //setActSafeP(true);
        //setActMonnetPeru(true);
        setActMonnetPeru(true);
        setActMonnetPeruYape(true);
        setActPagoEfectivo(true);
        setActDeposit(true);
        setActALpsPEN(true);
        setActKushkiTransPEN(true);
        setActKushkiEfectPEN(true);
        setActKushkiCardPEN(true);
        break;
      
      case 'BRL':
        //setActAstro(true);
        setActCoinspaid(true);
        setActBinanceBRL(true);
        setActPix(true);
        //setActRetail(true);
        
      break;
      
      case 'ARS':
        //setActAstro(true);
        //setActAstroARG(true);
        setActCoinspaid(true);
        setActBinanceOtroARG(true);
        setActDeposit(true);
        break;
      
      case 'BS.S':
        setActTotalPBNC(true);
        setActCoinspaid(true);
        setActBinanceOtroVES(true);
        setActTotalP(true);
        //setActTotalPBFC(true);
        setActDeposit(true);
        setActMibanco(true);
        break;
      
      case '$':
        //setActAstro(true);
        //setActSafeP(true);
        setActCoinspaid(true);
        setActBinanceDolar(true);
        setActDeposit(true);
      break;

      case 'CLP':
        setActAstroCH(true);
        setActCoinspaid(true);
        setActBinanceOtroCLP(true);
        setActMonnetChileTarjeta(true);
        setActMonnetChileBancos(true);
        setActDeposit(true);
        setActALpsEfectivoCHL(true);
        setActALpsTarjetaCHL(true);
        setActALpsTransfCHL(true);
      break;

      case 'BOB':
        setActCoinspaid(true);
        setActBinanceOtroBOB(true);
        setActPFtigomoney(true);
        //setActPFyape(true);
        setActPFqr(true);
        //setActPFqrbisa(true);
        //setActPFqrMercantil(true);
      break;

      case 'MXN':
        setActCoinspaid(true);
        setActBinanceOtroMXN(true);
        setActSpei(true);
        setActDeposit(true);
        setActOxxoMxn(true);
      break;

      case 'COP':
        setActAstroCO(true);
        setActCoinspaid(true);
        setActBinanceOtroCOP(true);
        setActDeposit(true);
      break;

      case 'DOP':
        setActCoinspaid(true);
        setActBinanceOtroDOP(true);
        setActDeposit(true);
      break;

      case 'EUR':
        setActCoinspaid(true);
        setActBinanceOtroEUR(true);
        setActDeposit(true);
      break;

      case 'GTQ':
        setActMonnetGTQCash(true);
        setActMonnetGTQTransf(true);
        setActDeposit(true);
      break;

      case 'PYG':
        setActBetterbroPYG(true);
        setActDeposit(true);
      break;
  
      default:
        setActDeposit(true);
        break
    }
  },[moneda]);
}

function useWrapperWithdraw(
  setActRetail,
  //setActAstro,
  setActDeposit,
  setActMonnetPeru,
  setActMonnetChile,
  setActPagoFacil,
  setActBinanceUSD,
  setActPix,
  setActSpei,
  setActBinanceBRL,
  setActBinanceOtroMXN,
  setActBinanceOtroARG,
  setActBinanceOtroCOP,
  setActBinanceOtroCLP,
  setActBinanceOtroDOP,
  setActBinanceOtroVES,
  setActBinanceOtroBOB,
  setActBinanceOtroEUR,
  setActCoinspaidRetiroBRL,
  setActCoinspaidRetiroMXN,
  setActCoinspaidRetiroARS,
  setActCoinspaidRetiroCOP,
  setActCoinspaidRetiroCLP,
  setActCoinspaidRetiroDOP,
  setActCoinspaidRetiroVES,
  setActCoinspaidRetiroBOB,
  setActCoinspaidRetiroEUR,
  setActCoinspaidRetiroUSD,
  setActALpsPE,
  setActALpsCH,
  setActKushki,
  setActMibancoRetiro,
  setActMonnetGuatemala,
  setActAstroCH,
  setActAstroCO,
  setActAstroARG,
  setActBetterbroPYG,
){
  const moneda = useSelector(selectCurrency);
    
  useEffect(()=>{
    switch (moneda.toUpperCase()) {
      case 'SOL':
        //setActAstro(true);
        setActMonnetPeru(true);
        setActDeposit(true);
        setActALpsPE(true);
        setActKushki(true);
        break;
      
      case 'BRL':
        //setActAstro(true);
        setActCoinspaidRetiroBRL(true);
        setActBinanceBRL(true);
        setActPix(true);
        //setActRetail(true);
      break;
      
      case 'ARS':
        //setActAstro(true);
        //setActAstroARG(true);
        setActCoinspaidRetiroARS(true);
        setActBinanceOtroARG(true);
        setActDeposit(true);
        break;
      
      case 'BS.S':
        setActCoinspaidRetiroVES(true);
        setActBinanceOtroVES(true);
        setActDeposit(true);
        setActMibancoRetiro(true);
        break;
      
      case '$':
        //setActAstro(true);
        setActCoinspaidRetiroUSD(true);
        setActBinanceUSD(true);
        setActDeposit(true);
        break;
      case 'CLP':
        setActAstroCH(true);
        setActCoinspaidRetiroCLP(true);
        setActBinanceOtroCLP(true);
        setActMonnetChile(true);
        setActDeposit(true);
        setActALpsCH(true);
      break;

      case 'BOB': 
        setActCoinspaidRetiroBOB(true);
        setActBinanceOtroBOB(true);
        setActPagoFacil(true);
      break;

      case 'MXN':
        setActCoinspaidRetiroMXN(true);
        setActBinanceOtroMXN(true);
        setActSpei(true);
        setActDeposit(true);
      break;

      case 'COP':
        setActAstroCO(true);
        setActCoinspaidRetiroCOP(true);
        setActBinanceOtroCOP(true);
        setActDeposit(true);
      break;

      case 'DOP':
        setActCoinspaidRetiroDOP(true);
        setActBinanceOtroDOP(true);
        setActDeposit(true);
      break;

      case 'EUR':
        setActCoinspaidRetiroEUR(true);
        setActBinanceOtroEUR(true);
        setActDeposit(true);
      break;

      case 'GTQ':
        setActMonnetGuatemala(true);
        setActDeposit(true);
      break;

      case 'PYG':
        setActBetterbroPYG(true);
        setActDeposit(true);
      break;
  
      default:
        setActDeposit(true);
        break
    }
  },[moneda]);
}

export {useWrapperWithdraw, useWrapperDeposit};